/**
 * Copyright (c) 2020 Google Inc
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

const exposed = {};
if (location.search) {
  var a = document.createElement("a");
  a.href = location.href;
  a.search = "";
  history.replaceState(null, null, a.href);
}

function share(anchor) {
  var url = anchor.getAttribute("href");
  navigator.share({
    url: url,
  });
}

function copy(elm) {
  var text = elm.getAttribute("data-copytext");
  var name = elm.getAttribute("data-copyname");
  navigator.clipboard
    .writeText(text)
    .then(() => alert(`${name} ${text} 複製成功`));
}

expose("share", share);

expose("copy", copy);

function prefetch(e) {
  if (e.target.tagName != "A") {
    return;
  }
  if (e.target.origin != location.origin) {
    return;
  }
  /**
   * Return the given url with no fragment
   * @param {string} url potentially containing a fragment
   * @return {string} url without fragment
   */
  const removeUrlFragment = (url) => url.split("#")[0];
  if (
    removeUrlFragment(window.location.href) === removeUrlFragment(e.target.href)
  ) {
    return;
  }
  var l = document.createElement("link");
  l.rel = "prefetch";
  l.href = e.target.href;
  document.head.appendChild(l);
}
document.documentElement.addEventListener("mouseover", prefetch, {
  capture: true,
  passive: true,
});
document.documentElement.addEventListener("touchstart", prefetch, {
  capture: true,
  passive: true,
});

/**
 * Injects a script into document.head
 * @param {string} src path of script to be injected in <head>
 * @return {Promise} Promise object that resolves on script load event
 */
const dynamicScriptInject = (src) => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.type = "text/javascript";
    document.head.appendChild(script);
    script.addEventListener("load", () => {
      resolve(script);
    });
  });
};

function expose(name, fn) {
  exposed[name] = fn;
}

function iframeLoad(wrapper) {
  const iframe = document.createElement("iframe");
  const src = wrapper.getAttribute("data-src");
  wrapper.removeAttribute("data-src");
  wrapper.removeAttribute("on-click");
  iframe.src = src;
  iframe.setAttribute("class", "csb");
  iframe.allow =
    "accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking";
  iframe.sandbox =
    "allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts";
  wrapper.removeChild(wrapper.firstChild);
  wrapper.appendChild(iframe);
}

expose("iframeLoad", iframeLoad);

function themeSwitch() {
  window.__setPreferredTheme(window.__theme === "dark" ? "light" : "dark");
}

expose("themeSwitch", themeSwitch);

function ytLoad(ytContent, e) {
  const isMobile = window.matchMedia("(max-width: 767px)").matches;
  if (isMobile) {
    return;
  }
  e.preventDefault();
  const iframe = document.createElement("iframe");
  const src = ytContent.getAttribute("data-src") + "?autoplay=1";
  ytContent.removeAttribute("data-src");
  ytContent.removeAttribute("on-click");
  iframe.setAttribute(
    "allow",
    "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
  );
  iframe.setAttribute("src", src);
  iframe.setAttribute("frameborder", "0");
  iframe.setAttribute("class", "youtube");
  const ytWrapper = ytContent.parentElement;
  ytWrapper.textContent = "";
  ytWrapper.appendChild(iframe);
}

expose("ytLoad", ytLoad);

addEventListener("click", (e) => {
  const handler = e.target.closest("[on-click]");
  if (!handler) {
    return;
  }
  const name = handler.getAttribute("on-click");
  const fn = exposed[name];
  if (!fn) {
    throw new Error("Unknown handler" + name);
  }
  fn(handler, e);
});

if (navigator.share) {
  const elm = document.getElementById("shareButton");
  if (elm) {
    elm.style = "";
  }
}
